import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ReportsProps {
  className?: string;
  width?: number;
  height?: number;
}

const ReportsIcon = function ReportsIcon({
  className,
  width,
  height,
}: ReportsProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 24"
    >
      <rect className={twMerge('fill-transparent', className)} x="4" y="6.5" width="17" height="14" rx="1.5" />
      <path fill="white" d="M4.00052 9.5C4.00265 8.8028 4.01353 8.28291 4.06876 7.87208C4.13453 7.3829 4.25483 7.12385 4.43934 6.93934C4.62385 6.75483 4.8829 6.63453 5.37208 6.56876C5.87565 6.50106 6.54306 6.5 7.5 6.5H17.5C18.4569 6.5 19.1244 6.50106 19.6279 6.56876C20.1171 6.63453 20.3762 6.75483 20.5607 6.93934C20.7452 7.12385 20.8655 7.3829 20.9312 7.87208C20.9865 8.28291 20.9973 8.8028 20.9995 9.5H4.00052Z" />
      <path className={twMerge('fill-transparent', className)} d="M7.5 3L7.5 6" strokeLinecap="round" />
      <path className={twMerge('fill-transparent', className)} d="M17.5 3L17.5 6" strokeLinecap="round" />
      <path className={twMerge('fill-transparent')} stroke="white" fill="white" d="M12.2658 12.7924C12.471 12.2641 12.5736 12 12.75 12C12.9264 12 13.029 12.2641 13.2342 12.7924L13.2438 12.817C13.3597 13.1154 13.4176 13.2647 13.5358 13.3554C13.6539 13.4461 13.809 13.4604 14.1191 13.4891L14.1752 13.4943C14.6827 13.5412 14.9365 13.5647 14.9908 13.7314C15.0451 13.8982 14.8566 14.0753 14.4797 14.4294L14.3539 14.5476C14.1631 14.7269 14.0677 14.8165 14.0232 14.934C14.0149 14.9559 14.008 14.9784 14.0026 15.0012C13.9733 15.1237 14.0013 15.2538 14.0571 15.5138L14.0745 15.5948C14.1772 16.0728 14.2286 16.3118 14.1389 16.4149C14.1054 16.4534 14.0619 16.4811 14.0135 16.4947C13.8841 16.5312 13.7003 16.3766 13.3328 16.0673C13.0915 15.8642 12.9708 15.7627 12.8323 15.7398C12.7778 15.7308 12.7222 15.7308 12.6677 15.7398C12.5292 15.7627 12.4085 15.8642 12.1672 16.0673C11.7997 16.3766 11.6159 16.5312 11.4865 16.4947C11.4381 16.4811 11.3946 16.4534 11.3611 16.4149C11.2714 16.3118 11.3228 16.0728 11.4255 15.5948L11.4429 15.5138C11.4987 15.2538 11.5267 15.1237 11.4974 15.0012C11.492 14.9784 11.4851 14.9559 11.4768 14.934C11.4323 14.8165 11.3369 14.7269 11.1461 14.5476L11.0203 14.4294C10.6434 14.0753 10.4549 13.8982 10.5092 13.7314C10.5635 13.5647 10.8173 13.5412 11.3248 13.4943L11.3809 13.4891C11.691 13.4604 11.8461 13.4461 11.9642 13.3554C12.0824 13.2647 12.1403 13.1154 12.2562 12.817L12.2658 12.7924Z" />
    </svg>
  );
};

ReportsIcon.defaultProps = {
  className: '',
  width: 25,
  height: 24,
};

export default ReportsIcon;
